export default "__VITE_ASSET__DaAJ3yuH__"